import { StageTrigger } from '@templates/index';
import { useUiStore } from '@store/index';

/** Sits next to TUNING and SYNTH so "adjust strings" (tuning) and
 *  "verify pitch" (tuner) feel paired. Stays visible while open and
 *  toggles the tuner overlay. */
export function TunerTrigger() {
  const open = useUiStore((s) => s.tunerOpen);
  const setOpen = useUiStore((s) => s.setTunerOpen);
  return (
    <StageTrigger
      label="TUNER"
      offsetLeft={180}
      onClick={() => setOpen(!open)}
      ariaLabel={open ? 'Close tuner' : 'Open tuner'}
      active={open}
    />
  );
}
